import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface Props {
  message: string;
  onClose: () => void;
  autoDismissMs?: number;
}

export default function CleanupHistoryInlineNotice({ message, onClose, autoDismissMs = 4000 }: Props) {
  useEffect(() => {
    const timer = setTimeout(onClose, autoDismissMs);
    return () => clearTimeout(timer);
  }, [onClose, autoDismissMs]);

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 right-6 bg-ink text-white rounded-lg px-4 py-3 shadow-[0_10px_24px_rgba(14,26,26,0.18)] flex items-center gap-3 z-50 border-l-2 border-teal-dark max-w-[400px]"
    >
      <div className="text-[13px] font-medium leading-tight">{message}</div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Dismiss"
        className="bg-transparent border-none cursor-pointer text-ink4 hover:text-white p-0 inline-flex items-center justify-center ml-auto"
      >
        <X size={14} />
      </button>
    </div>
  );
}